<template>
    <div class="left_panel custome_table_width manage_team_table">
        <div
            class="panel_head_wrap d-flex align-items-center justify-content-between mb_32"
        >
            <div class="panel_heading">
                <h2 class="font_size_20">Manage Team ({{ team_length }})</h2>
            </div>
            <div
                class="panel_head_right upload_img_panel d-flex align-items-center"
            >
                <router-link :to="{ name: 'CreateTeam' }" class="font_size_20"
                    >+ Create Team
                </router-link>
            </div>
        </div>
        <div
            class="account_table manage_player_table table-responsive pl_10 manage_team pr_10 mt_30 mb_50 semibold-table custom_table_height_auto"
        >
            <table class="table mb_0">
                <thead>
                    <tr>
                        <th class="sort">
                            <SortIcons
                                :lable="'TEAM/GROUP NAME'"
                                :listConfig="listConfig"
                                :sortBy="'name'"
                                @sorting="sorting($event)"
                            />
                        </th>
                        <th class="sort">MEMBERS</th>

                        <th class="sort">COACH NAME</th>
                        <th scope="col">
                            <div
                                class="d-flex font_size_16 text_primary_blue text-uppercase"
                            >
                                Action
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(teams, index) in teams_list" :key="index">
                        <td>
                            <div class="font_size_16 team_name">
                                <router-link
                                    :to="{
                                        name: 'TeamMember',
                                        params: { id: teams.id }
                                    }"
                                    class="link"
                                    style="color: #0579c1 !important"
                                    ><span class="pr_16"
                                        ><img
                                            alt=""
                                            style="width: 25px"
                                            :src="
                                                teams.logo_file
                                                    ? teams.logo_file
                                                    : '/maincss/images/fc_united_img.png'
                                            "
                                    /></span>
                                    {{ teams.name | capitalize }}
                                </router-link>
                            </div>
                        </td>
                        <td>
                            <span
                                v-html="associatePlayersName(teams.player)"
                            ></span>
                        </td>
                        <td class="team_coach">
                            <span
                                v-html="associateCoachName(teams.coach)"
                            ></span>
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <span class="pr_16">
                                    <router-link
                                        v-tooltip="'Edit!'"
                                        :to="{
                                            name: 'EditTeam',
                                            params: { id: teams.id }
                                        }"
                                        class="mr-1 edit-link"
                                        ><img
                                            src="/maincss/images/icons/pen.svg"
                                    /></router-link>
                                </span>
                                <span
                                    ><a
                                        v-tooltip="'Delete!'"
                                        href="#"
                                        data-toggle="modal"
                                        :data-target="
                                            '#delete-resource-' + teams.id
                                        "
                                        class="delete-link"
                                        ><img
                                            alt=""
                                            src="/maincss/images/icons/delete_dark.svg" /></a
                                ></span>
                            </div>
                        </td>
                        <DeleteResource
                            :target="'delete-resource-' + teams.id"
                            :path="'/teams/' + teams.id"
                            @updatelist="getTeams()"
                        />
                    </tr>
                </tbody>
            </table>
        </div>
        <VPagination :pages="pages" :currentPage.sync="currentPage" />
    </div>
</template>

<script>
import ApiService from "@/common/api.service";
import VPagination from "@/components/VPagination";
import SortIcons from "@/components/SortingIcons";
import DeleteResource from "@/components/DeletePopup";

export default {
    name: "ManageTeam",
    components: { VPagination, SortIcons, DeleteResource },
    data() {
        return {
            teams_list: [],
            players_list: [],
            team_length: 0,
            currentPage: 1,
            itemsPerPage: 10,
            listConfig: {
                offset: (this.currentPage - 1) * this.itemsPerPage,
                limit: this.itemsPerPage,
                sortBy: "",
                order: "ASC"
            }
        };
    },
    computed: {
        pages() {
            if (this.team_length <= this.itemsPerPage) {
                return [1];
            }
            return [
                ...Array(Math.ceil(this.team_length / this.itemsPerPage)).keys()
            ].map((e) => e + 1);
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) {
                return "";
            }
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    },
    watch: {
        currentPage(newValue) {
            this.listConfig.offset = (newValue - 1) * this.itemsPerPage;
            this.getTeams();
        }
    },
    mounted() {
        this.listConfig = {
            offset: (this.currentPage - 1) * this.itemsPerPage,
            limit: this.itemsPerPage,
            sortBy: "id",
            order: "DESC"
        };
        this.getTeams();
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
    },
    methods: {
        getTeams() {
            let _this = this;
            _this.isLoader = true;
            new Promise(() => {
                ApiService.post("/all-teams", _this.listConfig)
                    .then(({ data }) => {
                        _this.team_length = data.teams.count;
                        _this.teams_list = data.teams.rows;
                        _this.isLoader = false;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                    });
            });
        },
        associateCoachName(coach) {
            let final_html =
                `<div class="dropdown">
        <a href="#" class="dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">` +
                this.$options.filters.capitalize(coach.first_name) +
                " " +
                this.$options.filters.capitalize(coach.last_name) +
                `
        </a>
        <div class="dropdown-menu coach_drop-down" aria-labelledby="dropdownMenuButton">
       <div class="details_para"><div class="row">
      <div class="col-10 col-md-10"><div class="bill-details"><strong>` +
                coach.first_name +
                " " +
                coach.last_name +
                `</strong><br></div> </div>
                                 <div class="col-2 col-md-2"><div class="cross-btn"><svg xmlns="http://www.w3.org/2000/svg" width="15.636" height="15.636" viewBox="0 0 15.636 15.636">
    <path data-name="Path 9029" d="m176.116 174-4.442-4.442 4.442-4.442a1.5 1.5 0 1 0-2.116-2.121l-4.442 4.442-4.442-4.442a1.5 1.5 0 1 0-2.119 2.119l4.442 4.442-4.445 4.444a1.5 1.5 0 1 0 2.119 2.119l4.442-4.442 4.445 4.44a1.5 1.5 0 1 0 2.116-2.117z" transform="translate(-161.805 -161.669)" style="fill:#333;stroke:#fff;stroke-width:1.5px"/>
</svg></div></div>
      </div><div class="contact-info location"><span><img alt="" src="/maincss/images/icons/placeholder.svg"></span><span>` +
                coach.Profile.city +
                `</span></div><div class="contact-info"><span><img alt="" src="/maincss/images/icons/envelope.svg"></span><span><a href="mailto:` +
                coach.email +
                `">` +
                coach.email +
                `</a></span></div><div class="contact-info"><span><img alt="" src="/maincss/images/icons/call.svg"></span><span><a href="tel:` +
                coach.mobile +
                `">` +
                coach.mobile +
                `</a></span></div></div>
        </div></div>`;

            return final_html;
        },
        associatePlayersName(players) {
            var players_name = [];
            players.forEach((element) => {
                players_name.push(element.full_name);
            });
            players_name = players_name.sort();
            players_name = players_name.map((elemet) => {
                elemet = this.capitalFirstLetterOfEachWordString(elemet);
                return elemet;
            });
            return players_name.length > 0
                ? players_name.length > 3
                    ? players_name.slice(0, 3).join(", ") +
                      ' <div class="table_dropdown-menu d-inline-block position-relative td_link_dropdown left-align_dropdown"><span class="more_number" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><strong>+3</strong> </span><div class="dropdown-menu"> <div class="dropdown_header_custome"><div></div> <h4 class="link">Members</h4></div> <div class="dropdown_para">' +
                      players_name.join(" | ") +
                      "</div></div> </div>"
                    : players_name.join(", ")
                : "Players not assigned yet";
        },
        sorting($event) {
            var _this = this;
            _this.listConfig.sortBy == $event.sortBy;
            _this.listConfig.order == $event.orderBy;
            _this.getTeams();
        },
        capitalFirstLetterOfEachWordString(value) {
            if (!value) {
                return "";
            }
            const arr = value.split(" ");
            for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
            }
            const str2 = arr.join(" ");
            return str2;
        }
    }
};
</script>
